import Vue from 'vue';

import VueLazyload from 'vue-lazyload';
import VueMeta from 'vue-meta'

//Video
import {Plugin} from 'vue-responsive-video-background-player'


import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueAnalytics from 'vue-analytics';
import VueSimpleSVG from 'vue-simple-svg';
import 'swiper/dist/css/swiper.css';
import VueTabs from 'vue-nav-tabs';
import 'vue-nav-tabs/themes/vue-tabs.css';
import * as VueGoogleMaps from 'vue2-google-maps';
import { sync } from 'vuex-router-sync';
import 'normalize.css';
import App from './App';
import { httpRequestInterceptor, httpResponseInterceptor, httpResponseSuccessInterceptor } from './http';
import registerAxios from './axios';
import vueRouter from './router';
import store from './store';
import globalMixin from './mixins/global';
import registerFilters from './filters/global';
import helper from './shared/helper';
import './global-components';

const isProd = process.env.NODE_ENV === 'production';

const load = {
	load: {
		key: process.env.KEY_MAP,
	},
};


Vue.use(VueLazyload, {
	preLoad: 2,
	error: '/static/img/error.png',
	loading: '/static/img/load.jpg',
	attempt: 1,
	observer: true,
});

Vue.use(VueMeta, {
	keyName: 'metaInfo',
	attribute: 'data-vue-meta',
	ssrAttribute: 'data-vue-meta-server-rendered',
	tagIDKeyName: 'vmid',
	refreshOnceOnNavigation: false
})

Vue.use(Plugin);
Vue.use(VueTabs);
Vue.use(VueAwesomeSwiper);
Vue.use(VueGoogleMaps, load);
Vue.use(VueSimpleSVG);
const router = vueRouter(Vue);
sync(store, router);
registerFilters(Vue);
registerAxios(Vue);
Vue.prototype.$bus = new Vue();
Vue.prototype.$imageUrl = process.env.S3_IMAGES_URL;
Vue.config.productionTip = false;
Vue.mixin(globalMixin);

Vue.use(VueAnalytics, {
	id: 'UA-140525928-1',
	router,
	debug: {
		enabled: !isProd,
		sendHitTask: isProd,
	},
});

if (window.localStorage) {
	const localUserString = window.localStorage.getItem('user') || 'null';
	const localUser = JSON.parse(localUserString);

	if (localUser && store.state.user !== localUser) {
		store.commit('SET_USER', localUser);
		store.commit('SET_TOKEN', window.localStorage.getItem('token'));
	}
}

async function created() {
	const token = helper.getLocalToken() || store.state.token;

	this.$http.interceptors.request.use(this.httpRequestInterceptor);
	this.$http.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpAcl.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpAcl.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);

	console.log('main created')

	if (token) {
		helper.setLocalData(true, 'flag-admin');
	}
}

/* eslint-disable no-new */
new Vue({
	created,
	el: '#app',
	methods: {
		httpRequestInterceptor,
		httpResponseInterceptor,
		httpResponseSuccessInterceptor,
	},
	router,
	store,
	render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js